<script setup lang="ts">
import BannerOldKiosk from './BannerOldKiosk.vue';
import DateClock from './DateClock.vue';
import HeaderActiveUser from '@/components/HeaderActiveUser.vue';
import HeaderLocation from '@/components/HeaderLocation.vue';
import { useRootStore } from '@/stores/root';
import { checkFF } from '@/lib/util/checkFF';

import { useUserStore } from '@/stores/user';
import { computed } from 'vue';

const rootStore = useRootStore();
const user = useUserStore();
const isHomeScreen = computed(
  () => !rootStore.getInitializeError() && !user.data.activeUser
);
const isManager = computed(
  () =>
    user.data.activeUser?.CanApproveTimesheets &&
    !checkFF('LAUNCH_BRIGHTLY_WEB_TIME_CLOCK')
);
defineProps<{
  companyName?: string;
}>();
</script>

<template>
  <nav
    :class="{
      '--home': isHomeScreen,
    }"
  >
    <DateClock />
    <div class="__middle-container">
      <div id="navbar-teleported-content" v-if="isHomeScreen"></div>
      <BannerOldKiosk v-else-if="isManager" />
    </div>
    <div class="__right-container">
      <HeaderLocation v-if="isHomeScreen" :companyName="companyName" />
      <HeaderActiveUser />
    </div>
  </nav>
</template>

<style scoped>
nav {
  display: flex;
  justify-content: space-between;
  padding: 2rem 2rem 0;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 5;
  background: var(--co-background-primary);
}

@media (max-width: 480px) {
  nav {
    padding-inline: 1rem;
  }
}

@media (max-width: 1200px) {
  nav {
    flex-direction: row;
    align-items: center;
    position: relative;
    margin-bottom: 1rem;
  }
}

.__middle-container {
  width: 808px;
}

.__right-container {
  flex: 1;
}

@media (max-width: 1200px) {
  nav.--home {
    flex-wrap: wrap;
    gap: 1rem;
    align-items: baseline;
  }
  nav .__middle-container {
    display: none;
  }

  nav.--home .__middle-container {
    display: block;
    width: 100%;
    order: 3;
  }

  nav .__right-container {
    order: 2;
  }
}
</style>
